module.exports = __webpack_public_path__ + "static/media/(2023.10.13) Receivership-order-dated-june-9-2021.77aaec2d.pdf";